import React from 'react'
import { connect } from 'react-redux'
import GlobalLoadingIndicator from '../components/global-loading-indicator'
import BuyableBargainList from '../components/bargain-tickets/bargain-ticket-list'
import { Translate } from 'react-redux-i18n'
import * as API from '../utility/api'
import MenuContainer from '../components/mainpage-menu-container'
import produce from 'immer'
import { getEventCity } from '../utility/event-location'
import moment from 'moment'
import CityFilterCloud from '../components/search/city-filter-cloud'
import {
  enrichTicketsWithBuyerPricing,
  loadResalePricingRulesForTickets
} from '../utility/resale-pricing'

class Bargains extends React.Component {
  state = {
    bargainTickets: null,
    error: false,
    selectedCities: []
  }

  componentDidMount() {
    API.GET('tickets/bargains')
      .then(({ data }) => {
        const allTickets = Object.values(data).flatMap(
          ({ tickets }) => tickets || []
        )

        return loadResalePricingRulesForTickets(allTickets).then(rulesByDate => {
          const enriched = Object.fromEntries(
            Object.entries(data)
              .map(([eventId, eventData]) => {
                const tickets = enrichTicketsWithBuyerPricing(
                  eventData.tickets || [],
                  rulesByDate
                ).filter(ticket => {
                  const original = parseInt(ticket.original_price, 10)
                  return (
                    Number.isFinite(original) &&
                    ticket.buyer_total_amount < original
                  )
                })

                return [eventId, { ...eventData, tickets }]
              })
              .filter(([, eventData]) => eventData.tickets.length > 0)
          )

          this.setState({ bargainTickets: enriched })
        })
      })
      .catch(error => {
        this.setState({ error: true })
        console.log(error);
      })
  }

  // delete ticket function is made to be used differently
  // this wrapper is a bubble gum between bargain list and that function
  removeTicketFromListWrapper = signedIn => {
    return (dispatch, event, fn) => {
      return ticket => {
        if (signedIn) {
          this.removeFromList(event.id, ticket)
        }

        fn(event, dispatch)(ticket)
      }
    }
  }

  removeFromList = (eventId, ticket) => {
    const newTickets = produce(this.state.bargainTickets, draft => {
      draft[eventId].tickets = draft[eventId].tickets.filter(
        t => t.id !== ticket.id
      )
    })

    this.setState({
      bargainTickets: newTickets
    })
  }

  filteredBargainTickets = bargainTickets => {
    const { selectedCities } = this.state

    if (!selectedCities || selectedCities.length === 0) {
      return bargainTickets
    }

    const selectedCitySet = new Set(selectedCities)

    return Object.fromEntries(
      Object.entries(bargainTickets).filter(([, { event }]) => {
        return selectedCitySet.has(getEventCity(event))
      })
    )
  }

  render() {
    const { bargainTickets, error, selectedCities } = this.state
    const { events, dispatch, signedIn } = this.props
    const filteredTickets =
      bargainTickets && this.filteredBargainTickets(bargainTickets)
    const cityOptions = bargainTickets
      ? Array.from(
          new Set(
            Object.values(bargainTickets)
              .filter(({ event, tickets }) => {
                return (
                  tickets.length > 0 &&
                  getEventCity(event).trim().length > 0 &&
                  moment(event.last_sales_date).isSameOrAfter(moment())
                )
              })
              .map(({ event }) => getEventCity(event).trim())
              .filter(city => city.length > 0)
          )
        ).sort((a, b) => a.localeCompare(b, 'fi'))
      : []

    return (
      <div className="section">
        <MenuContainer />

        <h2>
          <Translate value="events.bargains" />
        </h2>
        <p>
          <Translate value="tickets.bargains_description" />
        </p>

        <div className="break-lg" />
        <div className="row">
          <div className="col-sm-6">
            <CityFilterCloud
              cities={cityOptions}
              selectedCities={selectedCities}
              onChange={cities => this.setState({ selectedCities: cities })}
              idPrefix="bargain-city"
            />
          </div>
        </div>
        <div className="break-md" />
        <div className="row">
          {bargainTickets ? (
            <React.Fragment>
              {Object.keys(filteredTickets).length > 0 && (
                <BuyableBargainList
                  isFetching={false}
                  tickets={filteredTickets}
                  events={events}
                  dispatch={dispatch}
                  removeTicketFromListWrapper={this.removeTicketFromListWrapper(
                    signedIn
                  )}
                />
              )}

              {Object.keys(filteredTickets).length === 0 && (
                <div className="col-sm-12">
                  <Translate value="events.no_events_found" />
                </div>
              )}
            </React.Fragment>
          ) : error ? (
            <div>Error</div>
          ) : (
            <div className="col-md-offset-6">
              <GlobalLoadingIndicator />
            </div>
          )}
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    events: state.events.events,
    signedIn: state.users.signedIn
  }
}

export default connect(mapStateToProps)(Bargains)
